export function RestaurantInfoDirective(restaurantInfoFactory) {
    'ngInject';
    return {
        restrict: 'E',
        replace: false,
        compile: function(templateElem, templateAttrs) {
            var data = JSON.parse(templateAttrs.payload);
            templateElem.removeAttr('payload');
            Reflect.deleteProperty(templateAttrs, 'payload');
            restaurantInfoFactory.setServerRenderedInfo(data.info);
        }
    };
}
